export enum AppNameLocation {
  Top,
  Bottom
}
